export default {
  index: [
    {
      path: '/freshOrderdis',
      component: resolve => require(['./freshOrderIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/orderdis/_router.js